// Tiny localStorage-backed cache for kiosk dropdown/reference data (hosts, purposes,
// gates, active briefings) so the Kiosk check-in flow can still render its forms when
// the gate has no internet connection. Written-through whenever a live fetch succeeds.
const PREFIX = "kiosk_cache_";

export function cacheSet(key, data) {
  try {
    localStorage.setItem(`${PREFIX}${key}`, JSON.stringify(data));
  } catch {
    // localStorage unavailable/full - non-fatal, cache is best-effort
  }
}

export function cacheGet(key, fallback = []) {
  try {
    const raw = localStorage.getItem(`${PREFIX}${key}`);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}
